import { initializeIcons } from "@fluentui/react";

const ICONS_INIT_FLAG = "__addoShareTeams_fluentIconsInitialized__";

export function initializeFluentIconsOnce() {
  if (typeof window !== "undefined" && window[ICONS_INIT_FLAG]) {
    return;
  }

  initializeIcons();
  if (typeof window !== "undefined") {
    window[ICONS_INIT_FLAG] = true;
  }
}
